export enum SOCIAL_PLATFORMS_NAMES {
  instagram = 'Instagram',
  facebook = 'Facebook',
  youtube = 'YouTube',
  tiktok = 'TikTok',
  twitter = 'Twitter',
  snapchat = 'Snapchat',
}
